import gql from 'graphql-tag';

export const GET_ALL_PRODUCTION_LICENSES_QUERY = gql`
  query getAllProductionLicenses {
    getAllProductionLicenses {
      licenseInfo {
        licenseId
        issued
        licenseType
      }
      unitIdentity {
        unitTypeId
        unitId
        macAddress
      }
    }
  }
`;

export const GET_SIGNED_LICENSE_QUERY = gql`
  query getSignedLicense($licenseId: ID!) {
    getSignedLicense(licenseId: $licenseId)
  }
`;

export const CREATE_PRODUCTION_LICENSE = gql`
  mutation ($unitTypeId: LicenseUnitType!, $unitId: ID!, $macAddress: String!) {
    createProductionLicense(unitTypeId: $unitTypeId, unitId: $unitId, macAddress: $macAddress)
  }
`;

export const CREATE_LICENSE = gql`
  mutation (
    $licenseType: LicenseType!
    $unitTypeId: LicenseUnitType!
    $unitId: ID!
    $expiryDate: DateString
    $macAddress: String
  ) {
    createLicense(
      licenseType: $licenseType
      unitTypeId: $unitTypeId
      unitId: $unitId
      expiryDate: $expiryDate
      macAddress: $macAddress
    )
  }
`;

export const DELETE_LICENSE = gql`
  mutation deleteLicense($id: ID!) {
    deleteLicense(id: $id)
  }
`;

export const GET_EHUB_RESET_TOKEN = gql`
  query getEhubResetToken($ehubId: ID!) {
    getEhubResetToken(ehubId: $ehubId)
  }
`;

export const GET_LICENCE_FOR_UNIT_BY_TYPE = gql`
  query getAllLicensesForUnitByType($unitId: ID!, $licenseType: LicenseType!) {
    getAllLicensesForUnitByType(unitId: $unitId, licenseType: $licenseType) {
      licenseInfo {
        licenseId
        issued
        licenseType
        expiryDate
      }
    }
  }
`;

export const GET_LICENCE_BY_UNIT = gql`
  query getAllLicensesForUnit($unitId: ID!) {
    getAllLicensesForUnit(unitId: $unitId) {
      licenseInfo {
        licenseId
        issued
        licenseType
      }
    }
  }
`;

export const GET_ALL_API_KEYS_QUERY = gql`
  query getAllApiKeys($type: API_TYPE) {
    getAllApiKeys(type: $type) {
      id
      type
      issuedTo
      permissions {
        resource
      }
    }
  }
`;

export const CREATE_API_KEY = gql`
  mutation ($type: String!, $issuedTo: String!, $permissions: [ApiKeyPermissionInput!]!) {
    createApiKey(type: $type, issuedTo: $issuedTo, permissions: $permissions)
  }
`;

export const GET_SIGNED_API_KEY_QUERY = gql`
  query getSignedApiKey($apiKeyId: ID!) {
    getSignedApiKey(apiKeyId: $apiKeyId)
  }
`;

export const DELETE_API_KEY = gql`
  mutation deleteApiKey($id: ID!) {
    deleteApiKey(id: $id)
  }
`;

export const UPDATE_UNIT_CONFIG_JSON = gql`
  mutation updateUnitRegistryConfig($id: ID!, $configUnit: ConfigUnitInput!) {
    updateUnitRegistryConfig(id: $id, configUnit: $configUnit)
  }
`;
